import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { history } from "../../../helpers/history";
import { routePaths } from "../../config/route-paths";
import TrackingStepper from "./view/_stepper";
import { makeStyles, withStyles } from "@material-ui/core";
import { Grid, Button, Typography, Card, CardContent, Divider, CircularProgress, Hidden } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Dialog, DialogContent, DialogActions, DialogTitle } from "@material-ui/core";
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { useMediaQuery } from "react-responsive";
import { adminService } from "../../../services";
import { trackingrequest } from "../e_tracking-pages/service/service";
import { config } from "../../../enviroment";
import { Skeleton } from "@material-ui/lab";
import EFooter from "../../e_home-page/e_footer-section/view/_footer";
import Close from "@material-ui/icons/Close";
import TrackingStepperMobile from "./view/_mobile_stepper";
import { useTranslation } from "react-i18next";
import { Link as RouterLink} from "react-router-dom";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: "93vh",
    },
    contentBg: {
        background: theme?.palette?.eLight?.base + " !important",
        padding: "1.5rem 1.5rem 0rem !important",
        paddingBottom: 0,
        [theme.breakpoints.down("xs")]: {
            padding: "0px !important",
            paddingBottom: "8%"
        },
    },
    heading: {
        fontWeight: "bold",
        marginTop: "4%",
        color: theme?.palette?.ePrimary?.base + "!important",
    },
    heading2: {
        fontWeight: "bold",
        color: theme?.palette?.ePrimary?.base + "!important",
    },
    backButton: {
        [theme.breakpoints.up("md")]: {
           // paddingTop: "6% !important",
           // paddingLeft:"0% !important",
           padding: "0"
        },
        color: theme?.palette?.ePrimary?.base,
    },
    dividerColor: {
        backgroundColor: theme?.palette?.eLight?.base,
        marginTop: "1%",
        width: "370%"
    },
    cardCont: {
        minHeight: "inherit",
        padding: "20px 30px !important"
    },
    content: {
        [theme.breakpoints.down("md")]: {
            align: "center"
        },
        color: theme?.palette?.eDark?.base
    },
    spinner: {
        minHeight: "350px",
        marginTop: "10%",
        display: "flex", height: "100%", alignItems: "center", border: "1px", justifyContent: "center"

    },
    position: {
        marginTop: "2%",
        paddingLeft: "2%",
        position: "static",
            bottom: "8%",
        [theme.breakpoints.down("md")]: {
            textAlign: "center",
            position: "static",
        }
    },
    error: {
        marginTop: "10%"
    },
    skeleton: {
        background: theme?.palette?.eLight?.base,
        color: theme?.palette?.eDark?.base
    },
    link:{
        color: theme?.palette?.ePrimary?.base + "!important"
    },backStyle: {
        padding: "0 8px !important",
        [theme.breakpoints.down("md")]: {
            "& .MuiButton-root": {
                padding: "0px !important"
            }
        },
    },
    rechargeHistoryStyle:{
        textDecoration: "underline",
        color: theme?.palette?.ePrimary?.base,
        fontWeight: "bold",
        marginTop: "5rem"
      },
      notificationdiv: {
        color: "#15537C",
        margin: "20px 0",
        '& .MuiTypography-body1': {
            fontSize: "14px",
            marginBottom: "15px"
        }
      },
      trackerheading: {
        padding: "0 9px !important",
      },
      notificationdate: {
        fontWeight: "900"
      },
      trackbody: {
        minHeight: "460px",
      }
}));
export default function TrackingStepsPage() {
    const [trackingCaseId, setTrackingCaseId] = useState();
    const [response, setResponse] = useState()
    const [errorresponse, setErrorResponse] = useState(false)
    const [documentsUploaded,setDocumentsUploaded]=useState()
    const isSmall = useMediaQuery({ query: "(max-width: 768px)" });
    const classes = useStyles();
    const [notifications, setNotifications] = useState([]);
    let backClick = (e) => {
        history.length >= 1 ? history.goBack() : history.push(routePaths.LOGIN);
    }
    useEffect(() => {
        if (window.location.pathname) {
            let caseId = window.location.pathname.split(
                `${routePaths.TRACK_REQUEST_STEPS}/`
            );
            setTrackingCaseId(caseId[1])
            if (caseId[1] === undefined) {
                history.push(routePaths.TRACK_REQUEST);
            }
        } else {
            history.push(routePaths.TRACK_REQUEST);
        }
    }, [window.location.pathname])

    const tenantCode = config.parameters.TENANT_CODE;
    useEffect(() => {
        if (trackingCaseId) {
            trackingrequest.createTrackingRequestRead(trackingCaseId, tenantCode)
                .then((res) => {
                    setDocumentsUploaded(res?.data?.createTrackingRequestRead)
                    setResponse(res?.data?.createTrackingRequestRead?.output);
                    setNotifications(res?.data?.createTrackingRequestRead?.output?.notifications);
                }
                )
                .catch((error) => {
                    setResponse()
                    if (error?.response && error?.response?.status === 400) {
                        setErrorResponse(error?.response?.data?.errors[0]?.message)
                    }
                })
        }
    }, [trackingCaseId])
    const { t: labels, ready: labelReady } = useTranslation("label-E_TRACKING_NEW_CONNECTION");
    const { t: contentdata, ready: contentReady } = useTranslation("content-E_TRACKING_NEW_CONNECTION")
    var notifykey = 0;
    return (
        <>
            {contentdata ?
                <Grid className={classes.contentBg}>
                    <Card className={classes.root}>
                        <CardContent className={classes.cardCont}>
                            <Grid container spacing={2} direction="column">
                                <Grid item xs={12} md={3} align="left" className={classes.backStyle}>
                                    <Button
                                        size="small"
                                        startIcon={<ArrowBackIosIcon fontSize="small" />}
                                        onClick={backClick}
                                        className={classes.backButton}
                                        variant="caption"
                                    >
                                        <b>{labelReady ? labels("E_TRACKING_BACK") : <Skeleton />}</b>
                                    </Button>
                                </Grid>
                                <Grid item xs={12} md={6} className={classes.trackerheading}>
                                {labelReady ? <Typography variant="h4" className={classes.heading2}>{labels("E_TRACKING_TITLE")}</Typography> : <Skeleton />}
                                </Grid>
                            </Grid>
                            <Divider className={classes.dividerColor} />
                            
                            {response ? <Grid item className={classes.trackbody}>
                               {isSmall ? <TrackingStepperMobile documentsUploaded={documentsUploaded} response={response} trackingCaseId={trackingCaseId} />
                                :
                               <TrackingStepper documentsUploaded={documentsUploaded} response={response} trackingCaseId={trackingCaseId} />} 
                                {notifications?.notification != '' && notifications &&
                                        <Grid container justify="center" align="center" className={classes.notificationalert}>
                                            <Grid item className={classes.notificationdiv}>
                                                { Array.isArray(notifications) ?
                                                notifications.map( (notify) => {
                                                    if(notify.notification !== ''){
                                                        if(notifykey < 5){
                                                            notifykey++
                                                            return (
                                                                <Typography>
                                                                    <div className={classes.notificationdate}>{notify.date}   </div>{<InfoOutlinedIcon fontSize="inherit" />}<div>   {notify.notification}</div>
                                                                </Typography>
                                                            )
                                                        }}
                                                    }) : (
                                                        <Typography>
                                                            <div className={classes.notificationdate}>{notifications?.date}   </div>{<InfoOutlinedIcon fontSize="inherit" />}<div>   {notifications?.notification}</div>
                                                        </Typography>
                                                    )}
                                            </Grid>
                                        </Grid>
                                }
                         {labelReady ? <Typography align="center" variant="body2"><RouterLink to={routePaths.LOGIN} className={classes.rechargeHistoryStyle}>
                        {labels("E_BACK_LOGIN")}
                        </RouterLink></Typography>: <Skeleton />}
                            </Grid> : errorresponse ? 
                            <Grid item align="center" className={classes.error}>
                                {labelReady ?
                                        <Typography variant="h6">{labels("E_TRACKING_NEW_CONNECTION_ERROR")} <a href={routePaths.TRACK_REQUEST} className={classes.link}>{labels("E_TRY")}</a></Typography>
                                        : <Skeleton />}
                            </Grid> :
                                <div className={classes.spinner}><CircularProgress /></div>}

                            <Grid className={classes.position}>
                                <Divider className={classes.dividerColor} />
                                {contentReady ?
                                    <Typography
                                        className={classes.content}
                                        variant="body2"
                                        dangerouslySetInnerHTML={{
                                            __html: contentdata("E_TRACKING_FOOTER")?.answer?.replace("*class*", classes.link),
                                        }}
                                    ></Typography>
                                    : <Skeleton />}
                            </Grid>
                        </CardContent>
                    </Card>
                    <Grid align="center"><EFooter /></Grid>
                </Grid>
                :
                <div className={classes.skeleton}> <Skeleton animation="wave" height={50} width="80%"></Skeleton>
                    <Skeleton animation="wave" height={50} width="80%" ></Skeleton>
                    <Skeleton animation="wave" height={50} width="80%" ></Skeleton>
                    <Skeleton animation="wave" height={50} width="80%"></Skeleton></div>}
        </>
    )
}